import { ChangeDetectionStrategy, Component, ElementRef, HostListener, Injector, afterNextRender, inject, signal } from '@angular/core';
import { I18nService } from '../../../core/services/i18n.service';
import { SUPPORTED_LANGUAGES } from '../../../core/i18n/languages';
import { TranslatePipe } from '../../pipes/translate.pipe';

/**
 * Header language switcher.
 *
 */
@Component({
  selector: 'app-language-selector',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './language-selector.component.html',
  styleUrl: './language-selector.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LanguageSelectorComponent {
  private readonly host: ElementRef<HTMLElement> = inject(ElementRef);
  private readonly i18n = inject(I18nService);
  private readonly injector = inject(Injector);

  readonly languages = SUPPORTED_LANGUAGES;

  readonly open = signal(false);
  readonly currentCode = this.i18n.language;

  current() {
    return this.languages.find((language) => language.code === this.currentCode()) ?? this.languages[0];
  }

  toggle(): void {
    this.open.update((value) => !value);
    if (this.open()) {
      // On short viewports the absolute menu ends below the fold; scroll the page until its last option is visible.
      afterNextRender(() => this.host.nativeElement.querySelector('.lang__list > li:last-child')?.scrollIntoView({ block: 'nearest' }), { injector: this.injector });
    }
  }

  select(language: typeof SUPPORTED_LANGUAGES[number]): void {
    void this.i18n.setLanguage(language.code);
    this.open.set(false);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.open() && !this.host.nativeElement.contains(event.target as Node)) {
      this.open.set(false);
    }
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.open()) {
      this.open.set(false);
    }
  }
}
